var SharedFooterUSPhoneNumberView, SupportEmailFormCallBackErrorView, SupportEmailFormUSMainView, SupportEmailFormUSV2FlexibleContactChannelsView, SupportEmailFormV2FlexibleContactChannelsTextView, SupportPhoneNumberCallBackView, SupportV1StepThreeBaseView, SupportV2USStepThreeView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportEmailFormUSMainView = require('../../email_form/US/main_view');

SharedFooterUSPhoneNumberView = require('../../../../../shared/frontend/views/footer/US/phone_number_view');

SupportPhoneNumberCallBackView = require('../../email_form/US/phone_number_call_back_view');

SupportV1StepThreeBaseView = require('../v1_base_view');

SupportEmailFormUSV2FlexibleContactChannelsView = require('../../email_form/US/v2_flexible_contact_channels');

SupportEmailFormV2FlexibleContactChannelsTextView = require('../../email_form/common/v2_flexible_contact_channel_text_view');

SupportEmailFormCallBackErrorView = require('../../email_form/common/call_back_error_view');

SupportV2USStepThreeView = (function(superClass) {
  extend(SupportV2USStepThreeView, superClass);

  function SupportV2USStepThreeView() {
    return SupportV2USStepThreeView.__super__.constructor.apply(this, arguments);
  }

  SupportV2USStepThreeView.prototype.getEmailFormView = function(options) {
    return new SupportEmailFormUSMainView(options);
  };

  SupportV2USStepThreeView.prototype.renderPhoneNumberView = function() {
    if (window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.shouldDisplayCallBackOption : void 0)) {
      return this.renderPhoneNumberCallBackView();
    } else {
      return this.renderNormalPhoneNumberView();
    }
  };

  SupportV2USStepThreeView.prototype.renderNormalPhoneNumberView = function() {
    return propagateEventBeforeReplacingElements(function() {
      var phoneNumberView;
      phoneNumberView = new SharedFooterUSPhoneNumberView();
      return phoneNumberView.render();
    });
  };

  SupportV2USStepThreeView.prototype.renderPhoneNumberCallBackView = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        _this.phoneNumberCallBackView = new SupportPhoneNumberCallBackView({
          mainView: _this
        });
        return _this.phoneNumberCallBackView.render();
      };
    })(this));
  };

  SupportV2USStepThreeView.prototype.shouldShowContactChannelView = function() {
    var ref;
    return window.evaluate((ref = window.experiments) != null ? ref.showFlexibleContactChannels : void 0);
  };

  SupportV2USStepThreeView.prototype.configureContactChannelView = function(options) {
    return new SupportEmailFormUSV2FlexibleContactChannelsView(options);
  };

  SupportV2USStepThreeView.prototype.renderContactChannelView = function() {
    var hideInbentaResults;
    SupportV1StepThreeBaseView.prototype.renderContactChannelView.apply(this, arguments);
    hideInbentaResults = (function(_this) {
      return function() {
        var inbentaResults;
        inbentaResults = $("#results:visible");
        if (inbentaResults.length > 0) {
          inbentaResults.hide();
          return clearInterval(_this.hideInbentaResultsInterval);
        }
      };
    })(this);
    return this.hideInbentaResultsInterval = setInterval(hideInbentaResults, 0);
  };

  SupportV2USStepThreeView.prototype.renderEmailForm = function() {
    if (this.hideInbentaResultsInterval) {
      clearInterval(this.hideInbentaResultsInterval);
    }
    return SupportV1StepThreeBaseView.prototype.renderEmailForm.apply(this, arguments);
  };

  SupportV2USStepThreeView.prototype.postEmailFormRenderCallBack = function() {
    return Groupon.Support.ContentModel.onInitStepThree();
  };

  SupportV2USStepThreeView.prototype.getContactChannelTextView = function(stepThreeView) {
    return new SupportEmailFormV2FlexibleContactChannelsTextView({
      mainView: stepThreeView,
      emailFormModel: stepThreeView.emailFormModel,
      isVertical: false,
      shouldShowCallBackFailureView: true
    });
  };

  SupportV2USStepThreeView.prototype.callBackErrorHandler = function(showAfterHoursMessage) {
    if (showAfterHoursMessage == null) {
      showAfterHoursMessage = false;
    }
    this.callBackErrorView = new SupportEmailFormCallBackErrorView({
      contactChannelTextView: this.getContactChannelTextView(this),
      showAfterHoursMessage: showAfterHoursMessage
    });
    this.callBackErrorView.render();
    this.$el.html(this.callBackErrorView.el);
    $('#help-wizard').append(this.$el);
    return this.callBackErrorView.postRenderhandler();
  };

  return SupportV2USStepThreeView;

})(SupportV1StepThreeBaseView);

module.exports = SupportV2USStepThreeView;

//# sourceMappingURL=data:application/json;base64,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
